import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api';
import template from './sign-out.component.html';
var SignOutComponentController = /** @class */ (function () {
    function SignOutComponentController() {
        this.loading = false;
        this.webStoreApiClient = getWebStoreApiClient();
    }
    Object.defineProperty(SignOutComponentController.prototype, "label", {
        get: function () {
            var _a;
            return (_a = this.customLabel) !== null && _a !== void 0 ? _a : "SignOut" /* SignOut */;
        },
        enumerable: false,
        configurable: true
    });
    SignOutComponentController.prototype.onSignOut = function () {
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.webStoreApiClient.signOut();
    };
    SignOutComponentController.$inject = [];
    return SignOutComponentController;
}());
export var SignOutComponent = {
    bindings: {
        customLabel: '<',
    },
    controller: SignOutComponentController,
    template: template,
};
